import Model from '~~/package/mapper/Model';

export class ProSkillAssureTemplateCreateModel extends Model {
    constructor(
        public title: string = "",
        public testTemplateDtos: TestTemplateListType[] = [],
        public timeZoneId: string = ""
    ) {
        super();
    }
}

export interface TestTemplateListType {
    testTemplateId: number;
    referenceUrlExposureFlag: boolean;
}
